import {
  ApplicationId,
  ApplicationView,
  CompetitiveGroupStatus,
} from '../../../../models/applications/applications';
import { apiSlice } from '../../api-slice';

const baseUrl = `${process.env.REACT_APP_APPLICATIONS_MANAGER_API_URL}/applications/admin-managed`;

export const adminApplicationsApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    setModeratorForApplication: builder.mutation<
      ApplicationView,
      {
        applicationId: ApplicationId;
        moderatorId: number;
      }
    >({
      query: ({ applicationId, moderatorId }) => ({
        url: `${baseUrl}/set-moderator/${applicationId}`,
        method: 'POST',
        params: {
          moderatorId,
        },
      }),
    }),

    setApplicationHasOriginalDocs: builder.mutation<
      ApplicationView,
      {
        applicationId: ApplicationId;
        status: boolean;
      }
    >({
      query: ({ applicationId, status }) => ({
        url: `${baseUrl}/set-has-original-documents/${applicationId}`,
        method: 'POST',
        params: {
          status,
        },
      }),
    }),

    forceWithdrawApplication: builder.mutation<ApplicationView, ApplicationId>({
      query: id => ({
        url: `${baseUrl}/approve-withdraw/${id}`,
        method: 'POST',
      }),
    }),

    changeCompetitiveGroupStatus: builder.mutation<
      void,
      {
        file: File;
        status: CompetitiveGroupStatus;
      }
    >({
      query: ({ file, status }) => {
        const data = new FormData();
        data.append('file', file);
        return {
          url: `${baseUrl}/change-competitive-group-status`,
          method: 'POST',
          params: {
            status,
          },
          body: data,
        };
      },
      invalidatesTags: ['ImportTasks'],
    }),
  }),
});

export const {
  useSetModeratorForApplicationMutation,
  useSetApplicationHasOriginalDocsMutation,
  useForceWithdrawApplicationMutation,
} = adminApplicationsApi;
